import classNames from 'classnames';

import { LabelBodySmall } from './LabelBodySmall';
import { LockIcon } from '../icons';

type Props = {
    segment: number;
    name: string;
    currentSegment: number;
    onChangeCurrentSegment: (segment: number) => void;
    style?: React.CSSProperties;
    className?: string;
    showLockIcon?: boolean;
};
export function SegmentButton({
    segment,
    name,
    currentSegment,
    onChangeCurrentSegment,
    className,
    style,
    showLockIcon = false,
}: Props) {
    const isCurrent = segment == currentSegment;
    return (
        <button
            onClick={() => onChangeCurrentSegment(segment)}
            style={style}
            className={classNames(
                className,
                'snap-center rounded-[10px] border px-20 py-10 text-left',
                {
                    'border-vibrant-blue': isCurrent,
                    'bg-vibrant-blue-10p': isCurrent,
                    'border-line-light': !isCurrent,
                    'bg-white': !isCurrent,
                },
            )}
        >
            <div className="flex flex-row">
                {showLockIcon && <LockIcon className="mr-10 self-center" />}
                <div className="flex flex-col">
                    <LabelBodySmall>Del {segment}</LabelBodySmall>
                    <LabelBodySmall
                        bold
                        color={isCurrent ? 'text-dark-blue' : null}
                    >
                        {name}
                    </LabelBodySmall>
                </div>
            </div>
        </button>
    );
}
